import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { AuthApi } from '../api-client/services';
import { AuthResponseDto } from '../api-client/models';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(private readonly authApi: AuthApi, private readonly userService: UserService) {
  }

  login(email: string, password: string) {
    return this.authApi.authLoginPost$Json({ body: { email, password } });
  }
  
  externalLogin(provider: string) {
    const returnUrl = `${window.location.origin}`;
    return this.authApi.authExternalProviderPost$Json({ provider });
  }

  refresh(currentToken: string) {
    return this.authApi.authRefreshPost$Json({ body: { accessToken: currentToken } } );
  }

  switchOrganization(organizationId: string) {
    return this.authApi.authSwitchOrganizationPost$Json({ body: { organizationId } });
  }

  logout() {
    return this.authApi.authLogoutPost();
  }

  logoutAll() {
    return this.authApi.authLogoutAllPost();
  }
}